import React, { useContext, useEffect } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { useRoutes, useNavigate } from 'react-router-dom';
import Router from './routes/Router';
import { baselightTheme } from "./theme/DefaultColors";
import axios from 'axios';
import { UserContext } from './views/authentication/auth/UserContext';
import { setNavigate } from './views/authentication/auth/axios-interceptors';

function App() {
  const routing = useRoutes(Router);
  const theme = baselightTheme;
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate); // Pass the navigate function to the interceptor
  }, [navigate]);

  useEffect(() => {
    async function fetchData() {
      try {
        const userId = localStorage.getItem("userID");
        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/users/${userId}`);
        if (data) {
          setUser({ name: data.name, email: data.email, role: data.role }); // Store user details in context
          localStorage.setItem("userRole", data.role);
        }
      } catch (error) {
        console.error('Error updating context:', error);
      }
    }
    fetchData();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {routing}
    </ThemeProvider>
  );
}

export default App;
